module.exports = __webpack_public_path__ + "img/komoditas.1b82d4ea.svg";